/**
 * Converte o valor do filtro em uma lista de strings não vazias.
 *
 * Aceita arrays ou textos separados por vírgulas ou quebras de linha. Ignora
 * itens que não são strings, remove espaços nas extremidades e descarta
 * entradas vazias após a máscara.
 *
 * @param value Valor digitado no filtro ou recuperado da URL (já convertido por `parseURLParams`).
 * @param maskFormatter Função opcional aplicada a cada item antes de remover os vazios.
 * @returns Lista normalizada, ou vazia se não houver valores válidos.
 */
export function normalizeTextArrayFilterValue(
  value: string | Array<string>,
  maskFormatter?: (value: string) => string
): Array<string> {
  const values: Array<unknown> = Array.isArray(value) ? value : [value];

  return values
    .filter((item): item is string => typeof item === "string")
    .flatMap(item => item.split(/[\r\n,]/))
    .map(item => {
      const trimmedValue = item.trim();

      return maskFormatter ? maskFormatter(trimmedValue).trim() : trimmedValue;
    })
    .filter(Boolean);
}
